export enum NotificationType {
    Error = 'error',
    Redirecting = 'redirecting',
    Success = 'success',
    Warning = 'warning',
    Success_Redirecting = 'success_redirecting',
}
